import { useState, useCallback, useEffect } from 'react';
import moment from 'moment';
import axios from 'axios';
import { pdf, Document, Page, View, Text, Image } from '@react-pdf/renderer';
import { useSearchParams } from 'react-router-dom';
import { Input, Form, Spin } from 'antd';
import {
  validateTransferReceiptAuth,
  getContactTransferReceipt,
  getTransferReceiptOrganization,
} from 'services/api';
import BrokersafeLogo from 'assets/icons/brokersafe_logo.svg';
import { downloadLink } from 'modules/helpers';
import { Root, PDFStyle } from './styles';
import { Organziation, Transfer } from './types';

const getPDFDocument = (
  data: Transfer,
  org: Organziation,
  imageUrl: string,
) => {
  if (!data) {
    return null;
  }

  console.log('ImageURL', imageUrl);
  console.log('org.Organization_Logo_URL', org.Organization_Logo_URL);

  return (
    <Document>
      <Page style={PDFStyle.body}>
        <View style={PDFStyle.header}>
          <View>
            {/* <Image style={PDFStyle.image} src={org.Organization_Logo_URL} /> */}
            <Image
              style={PDFStyle.image}
              src={{
                uri: org.Organization_Logo_URL,
                method: 'GET',
                headers: { 'Cache-Control': 'no-cache' },
                body: '',
              }}
            />
          </View>
        </View>
        <Text style={PDFStyle.title}>Payment Receipt</Text>
        <View style={PDFStyle.row}>
          <View style={PDFStyle.halfSection}>
            <Text style={PDFStyle.text}>Payee: {data.Contact_Name}</Text>
            <Text style={PDFStyle.text}>Payor: {org.Organization_Name}</Text>
          </View>
          <View style={PDFStyle.halfSection}>
            <Text style={PDFStyle.text}>
              Status: {data.Dwolla_Transfer_Status_Name}
            </Text>
            <Text style={PDFStyle.text}>
              Amount: ${(data.Amount || 0).toFixed(2)}
            </Text>
          </View>
        </View>
        <View style={PDFStyle.section}>
          <Text style={PDFStyle.text}>
            Initiation Date: {moment(data.Created_Date).format('MM/DD/yyyy')}
          </Text>
          <Text style={PDFStyle.text}>
            Completion Date: {moment(data.Completed_Date).format('MM/DD/yyyy')}
          </Text>
        </View>
        <View style={PDFStyle.section}>
          <Text style={PDFStyle.text}>
            Payment Method: {data.TransferTypeMethod || ''}
          </Text>
          <Text style={PDFStyle.text}>
            Payment ID: {data.Transfer_ID || ''}
          </Text>
        </View>
        <View style={PDFStyle.section}>
          <Text style={PDFStyle.text}>Notes: {data.Note}</Text>
        </View>
      </Page>
    </Document>
  );
};

const TransfersReceipt = () => {
  const [hasError, setError] = useState(false);
  const [searchParams] = useSearchParams();
  const guid = searchParams.get('guid');
  const [organziation, setOrganization] = useState<Organziation>();
  const [isSubmitting, setSubmitting] = useState(false);
  const getImageBlobFromUrl = async (url: string) => {
    try {
      const image = await axios
        .get(url, {
          responseType: 'blob',
        })
        .then((response) =>
          window.URL.createObjectURL(new Blob([response.data])),
        );
      return image;
    } catch (error) {
      return '';
    }
  };

  const getOrganization = useCallback(async () => {
    if (!guid) {
      return;
    }

    try {
      const organziationRes = await getTransferReceiptOrganization(guid);
      if (organziationRes.Organization_Name) {
        setOrganization(organziationRes);
      }
    } catch (error) {}
  }, [guid]);

  useEffect(() => {
    getOrganization();
  }, [getOrganization]);

  const onFinish = async (values: any) => {
    const payload = {
      guid,
      phone_number_last_digits: values.phone,
    };
    setSubmitting(true);
    try {
      const authRes = await validateTransferReceiptAuth(payload);
      const entirePhoneNumber = authRes.Customer_Phone;
      if (entirePhoneNumber.slice(-4) !== values.phone) {
        setError(true);
        setSubmitting(false);
        return;
      }

      const transferPk = authRes.Transfer_PK;
      const transferRes = await getContactTransferReceipt(transferPk);
      if (transferRes) {
        const imageUrl = await getImageBlobFromUrl(
          organziation!.Organization_Logo_URL,
        );
        const pdfData = getPDFDocument(transferRes, organziation!, imageUrl);
        if (pdfData) {
          const blob = await pdf(pdfData).toBlob();
          const url = URL.createObjectURL(blob);
          downloadLink(url, 'transfer.pdf');
        }
      }

      setSubmitting(false);
    } catch (error) {
      setError(true);
      setSubmitting(false);
    }
  };

  return (
    <Root>
      <div className="container">
        <header className="header">
          {organziation?.Organization_Logo_URL && (
            <img
              className="logo-wrapper"
              src={organziation?.Organization_Logo_URL}
              style={{ width: '100%', height: '100%' }}
              alt="brokersafe-logo"
            />
          )}
        </header>

        <Spin
          style={{ width: '100%', marginTop: 150 }}
          tip="One moment while we complete the verify."
          size="large"
          spinning={isSubmitting}
        >
          <p>
            In order to verify your identify, enter the last 4 digits of your
            mobile phone number.
          </p>
          <Form layout="vertical" name="nest-messages" onFinish={onFinish}>
            <Form.Item
              name="phone"
              className="phone-wrapper"
              rules={[
                {
                  required: true,
                  message: 'Required',
                },
                {
                  pattern: /^[0-9]{4}$/,
                  message: 'Invalid format',
                },
              ]}
            >
              <Input
                onChange={(e) => {
                  setError(false);
                  if (e.target.value.length === 4) {
                    onFinish({ phone: e.target.value });
                  }
                }}
              />
            </Form.Item>
          </Form>
          {(hasError || !guid) && (
            <p className="error">
              We were unable to validate the information provided.
            </p>
          )}
        </Spin>
      </div>
      <footer>
        <div className="tifle-logo-wrapper">
          <div>Powered By</div>
          <img src={BrokersafeLogo} alt="brokersafe-logo" />
        </div>
      </footer>
    </Root>
  );
};

export default TransfersReceipt;
